module.exports = __webpack_public_path__ + "img/playbutton4.5538732a.png";